var confirmCodeInterval = 60,
    confirmCodeTimer = false,
    confirmCodeTimerStartDate = false;


$(function() {
    if ($('input[name="phone"]').length > 0) $('input[name*="phone"]').mask('+7 (000) 000 00 00');
    if ($('input[data-mask-type="date"]').length > 0) $('input[data-mask-type="date"]').mask('00.00.0000');


    $('input[name*="phone"]').on('keyup', function(event) {
        var val = $(this).val();

        if (val.length <= 3) $(this).val('+7 ');
    });


    $('input[name*="phone"]').on('focus', function(event) {
        var val = $(this).val();

        if (val.length == 0) $(this).val('+7 ');
    });


    $('input[name*="phone"]').on('click', function(event) {
        var val = $(this).val();

        if (val == '+7 ') $(this)[0].selectionStart = 3;
    });


    $('input[name*="phone"]').on('blur', function(event) {
        var val = $(this).val();

        if (val == '+7 ') $(this).val('');
    });


    $('body').on('click', '.label-checkbox', function(event) {
        $(this).toggleClass('active');

        if ($(this).hasClass('has-error') && $(this).hasClass('active')) $(this).removeClass('has-error');
    });


    $('body').on('click', '.label-radio', function(event) {
        var container = $(this).parents('.radiobuttons-container'),
            form = $(this).parents('form'),
            label = $(this);

        if (label.hasClass('active')) {
            container.find('.label-radio').removeClass('active');
            label.addClass('active');
        }
        else {
            container.find('.label-radio').removeClass('active');
            label.addClass('active');
        }


        if ($(this).parents('.learners-list').length > 0) {
            if (!label.hasClass('with-status')) {
                if (form.hasClass('payment-regular-lesson')) {
                    var groupId = form.find('input[name="group_id"]').val(),
                        learnerId = label.find('input[name="learner_id"]').val();

                    ajaxGetRegularLessonPaymentTypes(groupId, learnerId);
                }
                else if (form.hasClass('payment-event')) {
                    var price = label.data('price'),
                        discount = label.data('discount'),
                        discountPriceSpan = $('.event-price-container .discount-price span:first-child'),
                        basicPriceContainer = $('.event-price-container .basic-price');

                    if (discount) {
                        price = Math.floor(price * (100 - discount) / 100);
                        discountPriceSpan.html(price.toString().replace(/(\d{1,3})(?=(?:\d{3})+$)/g, '$1 '));
                        basicPriceContainer.removeClass('invisible');
                    }
                    else {
                        discountPriceSpan.html(price.toString().replace(/(\d{1,3})(?=(?:\d{3})+$)/g, '$1 '));
                        basicPriceContainer.addClass('invisible');
                    }
                }
            }
        }


        if ($(this).parents('.payment-types-list').length > 0) {
            var groupId = form.find('input[name="group_id"]').val(),
                learnerId = $('.learners-list').find('.label-radio.active input[name="learner_id"]').val(),
                paymentType = $('.payment-types-list label.active').find('input[name="payment_type"]').val();

            ajaxGetRegularLessonPaymentLessons(groupId, learnerId, paymentType);

            if (label.hasClass('payment-type-subscription')) {
                var groupId = form.find('input[name="group_id"]').val(),
                    learnerId = form.find('.learners-list .label-radio.active input[name="learner_id"]').val(),
                    subscriptionId = form.find('.payment-types-list .label-radio.active input[name="payment_type"]').val(),
                    dateStart = form.find('.lessons-list .label-radio.active').data('date-start');

                if (dateStart) {
                    form.find('input[name="date_start"]').val(dateStart);
                    ajaxCheckPaymentSubscriptionPeriod(groupId, learnerId, subscriptionId, dateStart);
                    calculateEndRegularSubscriptionDate(dateStart);
                }
            }
            else if (label.hasClass('payment-type-fixed-subscription')) {
                var groupId = form.find('input[name="group_id"]').val(),
                    learnerId = form.find('.learners-list .label-radio.active input[name="learner_id"]').val(),
                    subscriptionId = form.find('.payment-types-list .label-radio.active input[name="payment_type"]').val(),
                    dateStart = form.find('.lessons-list .label-radio.active').data('date-start');

                // $('.fixed-subscription-period-container').find('.date-start-container').html(dateStart);
                // $('.fixed-subscription-period-container').find('.date-end-container').html($(this).data('date-end'));

                // ajaxCheckPaymentSubscriptionPeriod(groupId, learnerId, subscriptionId, dateStart, true);
            }
        }


        if ($(this).parents('.lessons-list').length > 0) {
            var groupId = form.find('input[name="group_id"]').val(),
                learnerId = form.find('.learners-list .label-radio.active input[name="learner_id"]').val(),
                subscriptionId = form.find('.payment-types-list .label-radio.active input[name="payment_type"]').val(),
                dateStart = label.data('date-start');

            if (!$('.payment-types-list .payment-type-once').hasClass('active') && !$('.payment-types-list .payment-type-free').hasClass('active')) {
                form.find('input[name="date_start"]').val(dateStart);
                ajaxCheckPaymentSubscriptionPeriod(groupId, learnerId, subscriptionId, dateStart);
                calculateEndRegularSubscriptionDate(dateStart);
            }
        }
    });


    $('body').on('click', '.submit-form', function(event) {
        event.preventDefault();
        var form = $(this).parents('form');

        runAjaxFormSubmit(form);
    });


    $('body').on('submit', 'form', function (event) {
        if (!$(this).hasClass('search-form')) {
            event.preventDefault();
        }
    });


    $('body').on('keydown', 'form', function (event) {
        if (event.keyCode === 13 && !$(this).hasClass('search-form')) {
            event.preventDefault();
            runAjaxFormSubmit($(this));
        }
    });


    $('form.instant-search-form input[name="q"]').on('keydown', function(event) {
        var form = $(this).parents('form');

        if (event.keyCode === 13) {
            event.preventDefault();
            if ($(this).val().trim() != '') form.submit();
        }
    });


    $('form.instant-search-form input[name="q"]').on('keyup', function(event) {
        var form = $(this).parents('form');

        if ($(this).val().trim() != '') ajaxInstantSearch(form);
        else form.find('.search-suggestions-wrapper .search-suggestion-container').empty().remove();
    });


    $('form.search-form .search-button').on('mouseenter', function(event) {
        $(this).parents('.search-field-container').addClass('hover');
    });


    $('form.search-form .search-button').on('mouseleave', function(event) {
        $(this).parents('.search-field-container').removeClass('hover');
    });


    $('form.search-form .search-button').on('click', function(event) {
        var form = $(this).parents('form');

        event.preventDefault();

        if (form.find('input[name="q"]').val().trim() != '') form.submit();
    });


    $('.get-confirm-code-button').on('click', function(event) {
        var form = $(this).parents('form');

        if (!$(this).hasClass('invisible')) {
            var action = $(this).data('action');

            if (action == 'signup')	ajaxSignUpGetConfirmCode(form);
            if (action == 'change-phone') ajaxProfileGetConfirmCode(form);
        }
    });


    $('form.profile-form .avatar-border-container').on('click', function(event) {
        $('input[type=file][name="avatar_file"]')[0].click();
    });


    $('body').on('change', 'input[type=file][name="avatar_file"]', function(event) {
        var minWidth = 360,
            minHeight = 360,
            file = $(this)[0].files[0],
            errorMessage = 'Только JPG, не более 1 Мб и не менее ' + minWidth + 'x' + minHeight + ' px';

        if (!file.type.match(/image\/jpeg/) || file.size > 1024*1024) {
            showNotification(errorMessage, 'error');
        }
        else {
            var img = new Image();

            img.onload = function() {
                if (this.width < minWidth || this.height < minHeight) showNotification(errorMessage, 'error');
                else ajaxProfileUploadAvatar();
            };

            img.src = window.URL.createObjectURL(file);
        }
    });
});


// Выполняет TRIM для всех полей формы
function trimFormFields(jqForm) {
    jqForm.find('input, teatarea').not(':file').each(function() {
        $(this).val($.trim($(this).val()));
    });
}


// Выполняет соответствующую ajax-функцию, отправляющую данные формы
function runAjaxFormSubmit(form) {
    if (validateFormFields(form)) {
        if (form.hasClass('signin')) {
            ajaxSignIn(form);
        }
        else if (form.hasClass('signup')) {
            console.log(form);
            grecaptcha.ready(function() {
                grecaptcha.execute(
                    form.data('sitekey'),
                ).then(function(token) {
                    form.find('#captcha').val(token);
                    ajaxSignUp(form);
                });
            });
        }
        else if (form.hasClass('confirm-code')) {
            var action = form.find('.submit-form').data('action');

            if (action == 'signup')	ajaxSignUpSendConfirmCode(form);
            if (action == 'change-phone') ajaxProfileSendConfirmCode(form);
        }
        else if (form.hasClass('password-recovery')) {
            ajaxPasswordRecovery(form);
        }
        else if (form.hasClass('set-new-password')) {
            ajaxSetNewPassword(form);
        }
        else if (form.hasClass('pre-entry-event')) {
            ajaxPreEntryEvent(form);
        }
        else if (form.hasClass('payment-event')) {
            ajaxPaymentEvent(form);
        }
        else if (form.hasClass('payment-regular-lesson')) {
            ajaxPaymentRegularLesson(form);
        }
        else if (form.hasClass('review-form')) {
            ajaxSendReview(form);
        }
        else if (form.hasClass('profile-form')) {
            ajaxProfileUserEdit(form);
        }
        else if (form.hasClass('change-password')) {
            ajaxProfileChangePassword(form);
        }
        else if (form.hasClass('change-phone')) {
            ajaxProfileChangePhone(form);
        }
        else if (form.hasClass('add-learner')) {
            ajaxProfileAddLearner(form);
        }
        else if (form.hasClass('edit-learner')) {
            ajaxProfileEditLearner(form);
        }
    }
}


// Запускает таймер для отправки следующего кода подтверждения во время регистрации на сайте
function startConfirmCodeTimer() {
    var confirmCodeTimerStartDate = new Date();

    $('.get-confirm-code-button').addClass('invisible');
    $('.confirm-code-timer').removeClass('invisible').find('span').html(confirmCodeInterval);

    clearInterval(confirmCodeTimer);
    confirmCodeTimer = setInterval(function() {
        var now = new Date(),
            difference = Math.round((confirmCodeTimerStartDate - now) / 1000 + confirmCodeInterval);

        if (difference <= 0) {
            clearInterval(confirmCodeTimer);
            $('.confirm-code-timer').addClass('invisible');
            $('.get-confirm-code-button').removeClass('invisible');
        }
        else {
            $('.confirm-code-timer span').html(difference);
        }
    }, 1000);
}


// Вычисляет дату окончания срока действия абонемента
// setNow — если true, то в первое поле устанавливается текущая дата или дата открытия группы
function calculateEndSubscriptionDate(setDate) {
    var form = $('form.payment-regular-lesson'),
        groupId = form.find('input[name="group_id"]').val(),
        subscriptionId = form.find('.label-radio.active input[name="payment_type"]').val(),
        dateStart = form.find('input[name="date_start"]').val(),
        setNow = setNow ? setNow : false,
        interval = $('.payment-types-list .label-radio.active').data('months'),
        startDate = false,
        endDate = false,
        regExp = /^\d{2}\.\d{2}\.\d{4}$/;


    if (setDate) {
        var dateOpen = $('.js-subscription-period input').data('date-open');
        now = new Date(),
        currentDay = addZero(now.getDate()),
        currentMonth = addZero(now.getMonth() + 1),
        startDate = currentDay + '.' + currentMonth + '.' + now.getFullYear();

        if (dateOpen && regExp.test(dateOpen)) {
            var splitValues = dateOpen.split('.');

            $('.js-subscription-period input[name=date_start]').val(dateOpen);
            endDate = new Date(parseInt(splitValues[2]), parseInt(splitValues[1]) - 1 + interval, parseInt(splitValues[0]) - 1);
        }
        else {
            $('.js-subscription-period input[name=date_start]').val(startDate);
            endDate = new Date(now.getFullYear(), now.getMonth() + interval, now.getDate() - 1);
        }

        endDate = endDate.getDate() + '.' + addZero(endDate.getMonth() + 1) + '.' + endDate.getFullYear();
        $('.js-subscription-period .date-end-container').html(endDate);
    }
    else {
        var inputValue = $('.js-subscription-period input').val();

        if (regExp.test(inputValue) && isValidDate(inputValue)) {
            var splitValues = inputValue.split('.');

            endDate = new Date(parseInt(splitValues[2]), parseInt(splitValues[1]) - 1 + interval, parseInt(splitValues[0]) - 1);
            endDate = endDate.getDate() + '.' + addZero(endDate.getMonth() + 1) + '.' + endDate.getFullYear();
            $('.js-subscription-period .date-end-container').html(endDate);

            if (!$('.payment-types-list .payment-type-once').hasClass('active') && !$('.payment-types-list .payment-type-free').hasClass('active')) {
                var learnerId = $('.learners-list').find('.label-radio.active input[name="learner_id"]').val();
                ajaxCheckPaymentSubscriptionPeriod(groupId, learnerId, subscriptionId, dateStart);
            }
        }
        else {
            $('.js-subscription-period .date-end-container').html('00.00.0000');
            $('.js-subscription-period .check-amount-container').addClass('invisible');
        }
    }
}

function calculateEndRegularSubscriptionDate(dateStart) {
    var interval = ($('.payment-type-subscription.active').data('weeks') - 1) * 7,
        regExp = /^\d{2}\.\d{2}\.\d{4}$/,
        ruMonthsName = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];

    var now = new Date(),
        endDate = '';

    if (dateStart && regExp.test(dateStart)) {
        var splitValues = dateStart.split('.');

        endDate = new Date(parseInt(splitValues[2]), parseInt(splitValues[1]) - 1, parseInt(splitValues[0]) + interval);
    }
    else {
        endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + interval);
    }

    endDate.setDate(getSundayDate(endDate));
    endDate = endDate.getDate() + ' ' + ruMonthsName[endDate.getMonth()] + ' ' + endDate.getFullYear();

    $('.end-date-block__date').html(endDate);
}